<template>
<div>
    <h1>IBAN Gegevens</h1>
    <iban @update="updateIban" @valid="validateIban" :account="profile.iban"></iban>
    <div class="form-group">
        <label for="accountname" class="form-label">Ten name van:</label>
        <input :class="['form-control bg-light', (isBankAccountNameValid) ?'is-valid' : 'is-invalid']" id="accountname" name="accountname" placeholder="Ten name van" v-model="profile.bankAccountName" /> 
        <div class="invalid-feedback">
            Verplicht!
        </div>
    </div>
    <div class="form-group text-right">
        <button class="btn btn-outline-azure" @click="save" type="button" :disabled="!isValid" >Opslaan</button>
    </div>
</div>
</template>

<script>
import IBAN from '@/components/IBAN'
export default{
    props: ['user'],
    components: {
        'iban': IBAN
    },
    data() {
        return {
            ibanValid: false
        }
    },
    mounted() {
        const iban = this.profile.iban;
        this.updateIban('');
        setTimeout(() =>{
            this.updateIban(iban);

        }, 1)
    },
    methods:
    {
        validateIban(valid)
        {
            this.ibanValid = valid
        },
        updateIban(iban) {
            this.profile.iban = iban;
            this.ibanValid = true;
        },
        save() {
            if(this.isValid)
            {
                this.$emit('loading', true);
                this.$http.post('api/User/SaveProfessionalPayment', { 
                    IBAN: this.profile.iban,
                    bankAccountName: this.profile.bankAccountName
                }).then(() => {
                    this.$emit('loading', false);
                })
            }
        }
    },
    computed:
    {
        isValid() {
            if(this.isBankAccountNameValid && this.ibanValid)
            {
                return true;
            }
            return false;
        },
        isBankAccountNameValid() {
            if(!!this.profile.bankAccountName && this.profile.bankAccountName.length > 2)
            {
                return true;
            }
            return false;
        },
        profile() {
            if(this.user)
            {
                return this.user.professionalProfile;
            }
            return {};
        }
    }
}
</script>

<style scoped>
img {
    opacity: 0.5
}
img:hover {
    opacity: 1;
}
</style>

